import * as type from '../constants/ActionTypes';
import { CALL_API } from '../login/api.middleware';
import { AFFILIATE_SERVICE_URL } from '../constants/api';


export function postExternalHash(name, hash, currentAffiliateId) {

  const body = {
    name: name,
    externalHashId: hash,
    affiliateId: currentAffiliateId
  };

  let config = {
    method: 'POST',
    body: JSON.stringify(body)
  };

  return {
    [CALL_API]: {
      endpoint: `${AFFILIATE_SERVICE_URL}/affiliates/externalHashId`,
      config,
      authenticated: true,
      types: [
        type.POST_HASH_REQUEST,
        type.POST_HASH_SUCCESS,
        type.POST_HASH_FAILURE
      ]
    }
  };
}
